module.exports = __webpack_public_path__ + "img/account-rejected@2x.dd48896d.png";